import { defineStore } from 'pinia'

import type { LessonsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createLessonsState } from './state'

export const useLessonsStore = defineStore('lessons', {
  state: (): LessonsStore => createLessonsState(),
  actions,
  getters,
})
